import { IGetUnitsRequestParams } from "Dashboard/domain/IGetUnitsRequestParams";
import { IGetUnitsResponse } from "Dashboard/domain/IGetUnitsResponse";
import { IUnit } from "Dashboard/domain/IUnit";
import { IMessage } from "domain/IMessage";
import API from "utils/API";
import authHeader from "utils/auth-header";
import { getQeuryParams } from "utils/queryParamsUtil";

const getUnits = async (
  params: IGetUnitsRequestParams | undefined
): Promise<IUnit[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetUnitsResponse>(
      `/common/public/unit${getQeuryParams(params)}`,
      { headers }
    );
    return response.data.units;
  } catch (err) {
    throw err;
  }
};

const uploadExcelFile = async (exportData: any): Promise<IMessage> => {
  const data = new FormData();
  data.append("exportData", exportData);
  var headers = {
    "Content-Type": "multipart/form-data",
    ...authHeader(),
  };
  try {
    const response = await API.post<IMessage>(
      "/common/noauth/load-data-from-filemaker-export",
      data,
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
};

const loadInitialData = async (): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.post<IMessage>(
      "/common/noauth/load-initial-data",
      {},
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
};

const deleteAllData = async (): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.post<IMessage>(
      "/common/noauth/delete-all-data",
      {},
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
};

export const commonService = {
  getUnits,
  uploadExcelFile,
  loadInitialData,
  deleteAllData,
};
